module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"レビュー詳細を見る","product_button_label":"この商品の全レビューを見る"}}')
  delete Component.options._Ctor
}
